import { useContent } from "@/context/ContentContext";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export default function WhatsAppButton() {
  const { content } = useContent();
  const number = content?.contact?.whatsapp_number || "917895201529";
  const message = content?.contact?.whatsapp_message || "Hi TMF, I'd like a quote for";
  const href = `https://wa.me/${number.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;

  return (
    <a
      data-testid="whatsapp-support-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with TMF support on WhatsApp"
      className="fixed bottom-5 right-5 z-50 wa-pulse bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg transition-transform hover:scale-110"
    >
      <WhatsAppIcon size={28} />
    </a>
  );
}
